import { render, staticRenderFns } from "./ConfigurableProduct.vue?vue&type=template&id=589b3491&scoped=true&"
import script from "./ConfigurableProduct.vue?vue&type=script&lang=js&"
export * from "./ConfigurableProduct.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurableProduct.vue?vue&type=style&index=0&id=589b3491&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589b3491",
  null
  
)

export default component.exports